import { useShopifyStorefrontClient } from '@ifixit/shopify-cart-sdk/hooks';
import {
   PriceTag as BasePriceTag,
   type PriceTagProps as BasePriceTagProps,
} from '@ifixit/ui/components/price-tag';

type UserPriceTagProps = Omit<BasePriceTagProps, 'storeCode'>;

export function UserPriceTag(props: UserPriceTagProps) {
   const { storeCode } = useShopifyStorefrontClient();
   return <BasePriceTag storeCode={storeCode} {...props} />;
}
